import { render, staticRenderFns } from "./AiMyprDialog.vue?vue&type=template&id=b52a0d34"
import script from "./AiMyprDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiMyprDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AiMyprDialog.vue?vue&type=style&index=0&id=b52a0d34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports